<template>
  <div class="popstyle2" style="padding: 0 12px;">
    <b-modal id="logs-management-modal" ref="logsActividadManagementModal" size="lg" :title="modalTitle"
             centered :hide-footer="true" style="margin-top: 0" @hidden="onHidden" disabled="true">

      <b-card class="mb-16">
        <b-form>
          <b-row>
            <b-col :cols='2'>
              <b-form>
                Fecha inicio
                <datepicker class="margin-top-10" placeholder="Seleccionar Fecha" :bootstrap-styling='true'
                            v-model="inputs.dateStart.value"
                            :format='customFormatter'></datepicker>
              </b-form>
            </b-col>
            <b-col :cols='2'>
              <b-form>
                Fecha Fin
                <datepicker class="margin-top-10 datep" placeholder="Seleccionar Fecha" :bootstrap-styling='true'
                            v-model="inputs.dateEnd.value"
                            :format='customFormatter'></datepicker>
              </b-form>
            </b-col>
            <b-col class="right-side">
              <b-form>
                <b-button class="btn-lg margin-top padding-btn align-button" @click='submitFilters' variant="primary">Buscar
                </b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-form>
      </b-card>

      <b-card v-if="showLogsList">
        <b-row>
          <b-col :cols='12'>
            <h5>Resultados Logs</h5>
            <!--<LogsList :permisos="permisos" :data='resultsData'></LogsList>-->
            <div>
              <!-- Botones -->
              <div style="margin-bottom: 16px; display: flex;">
                <b-button class="ml-1" @click="exportar" style="display: flex; flex-direction: row; align-items: center;">
                  <i class='p-0 fa fa-download' style="margin-right: 8px;"></i> Exportar a XLS
                </b-button>
              </div>

              <!-- Listado de Logs Actividad -->
              <v-server-table
                v-if="!loading"
                ref="logs-actividad-table"
                url="lista-logs-actividad/"
                class="table-hide-nativetoggler"
                :columns="columns"
                :options="options">

                <div slot="fecha" class="" slot-scope="props">
                  <span class=""> {{ props.row.fecha | formatDate }}</span>
                </div>

                <div slot="usuario_ejecutor" slot-scope="props">
                  <span>{{ props.row.usuario_ejecutor }} </span>
                </div>

                <template v-if="options.details" slot="child_row" slot-scope="props" uniqueKey="id"></template>
              </v-server-table>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
  </div>
</template>

<style>
  .mb-16 {
    margin-bottom: 16px;
  }

  .right-side {
    text-align: right !important;
  }

  .padding-btn {
    padding-left: 35px;
    padding-right: 35px;
  }
  .table thead th {
    position: sticky;
    top: 0;
  }
  .align-button {
    margin-top: 20px;
  }

  tr.tr-logs-actividad-table td {
    padding-bottom: 4px !important;
    padding-top: 4px !important;
    vertical-align: middle;
  }

  @media (max-width: 979px) {
    .padding-btn {
      padding-left: 30px;
      padding-right: 30px;
    }
  }

  .table-responsive {
    padding-bottom: 0 !important;
    overflow-y: auto;
    max-height: 50vh;
  }

</style>

<script>
import Loader from '@/components/Layout/Loader.vue';
import Table from '@/components/Modules/Table/Table.vue';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import EventBus from '../../../Modules/EventBus';
import * as FileSaver from 'file-saver';

export default {
  name: 'LogsActividad',
  props: ['permisos'],
  components: {Loader, Table, Datepicker},
  data () {
    return {
      loading: 0,
      showLogsList: false,
      refresh_token: false,
      options: {
        rowClassCallback: () => {
          return 'tr-logs-actividad-table';
        },
        draggable: false,
        filterByColumn: true,
        filterable: ['fecha', 'usuario_ejecutor', 'accion', 'tipo_elemento', 'usuario', 'entidad', 'lote', 'descripcion'],
        sortable: ['fecha', 'usuario_ejecutor', 'accion', 'tipo_elemento', 'usuario', 'entidad', 'lote', 'descripcion'],
        dateColumns: ['fecha'],
        dateFormat: 'YYYY/MM/DD HH:MI:SS',
        perPage: 15,
        perPageValues: [],
        pagination: {
          chunk: 10,
          dropdown: false
        },
        params: {
          'paginated': true,
          'dateStart': null,
          'dateEnd': null,
          'fecha': true
        },
        orderBy: {
          ascending: false
        },
        requestKeys: {
          query: 'search',
          orderBy: 'ordering',
          limit: 'page_size'
        },
        skin: 'table-hover',
        sortIcon: {
          base: 'fa',
          up: 'fa-caret-down',
          down: 'fa-caret-up',
          is: 'fa-sort'
        },
        datepickerOptions: {
          showDropdowns: true
        },
        headings: {
          fecha: 'Fecha y hora',
          usuario_ejecutor: 'Usuario ejecutor',
          accion: 'Acción',
          tipo_elemento: 'Elemento',
          usuario: 'ID usuario',
          entidad: 'ID entidad',
          lote: 'ID lote',
          descripcion: 'Descripción'
        },
        requestFunction: function (data) {
          this.loading = true;
          let params = Object.keys(data.search);

          // for each column in the table
          for (let index = 0; index < params.length; index++) {
            const element = params[index];

            // Filtros iniciales
            let vale = data[element];
            if (vale) {
              if (element === 'fecha') {
                data[element + '__gte'] = data['dateStart'];
                data[element + '__lte'] = data['dateEnd'];
              }
            }

            // Filtros de la tabla
            let val = data.search[element];
            if (val) {
              if (element === 'fecha') {
                data[element + '__date__gte'] = val.start;
                data[element + '__date__lte'] = val.end;
              } else if (element === 'usuario' || element === 'lote' || element === 'entidad') {
                data[element + ''] = val;
              } else {
                data[element + '__icontains'] = val.trim();
              }
            }
          }

          // Eliminamos los atributos "search" y "byColumn" para no pasarlos como parametros
          delete data.search;
          delete data.byColumn;

          // Realizamos la petición
          return this.$http.get(this.url, {params: data}).then(function (data) {
            this.loading = false;
            return data.json();
          }, function (e) {
            this.loading = false;
            this.dispatch('error', e);
            EventBus.$emit('show-error-alert', 'Error al recuperar el listado de logs');
          }.bind(this));
        },
        responseAdapter: function (resp) {
          return {
            data: (resp) ? resp.results : [],
            count: (resp) ? resp.count : 0
          };
        }
      },
      requestKeys: {
        query: 'search',
        orderBy: 'ordering',
        limit: 'page_size'
      },
      params: {
        'paginated': true,
        'startDate': null
      },
      resultsData: null,
      modalTitle: 'Consulta de Logs de Actividad',
      inputs: {
        dateStart: {
          value: null
        },
        dateEnd: {
          value: null
        }
      },
      columns: ['fecha', 'usuario_ejecutor', 'accion', 'tipo_elemento', 'usuario', 'entidad', 'lote', 'descripcion'],
      downloading: false
    };
  },
  computed: {},
  mounted: function () {
    this.$refs.logsActividadManagementModal.show();
  },
  filters: {
    formatDate: function (date) {
      return (date) ? moment(date).format('YYYY-MM-DD  HH:mm:ss') : '';
    }
  },
  methods: {
    onHidden: function () {
      this.details = false;
      this.$parent.showLogsActividad = false;
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD');
    },
    submitFilters () {
      if (this.inputs.dateStart.value == null || this.inputs.dateEnd.value == null) {
        EventBus.$emit('show-warning-alert', 'Es necesario seleccionar fecha inicio y fecha fin para realizar la búsqueda');
        return;
      } else {
        this.options.params.dateEnd = moment(this.inputs.dateEnd.value).format('YYYY-MM-DD 23:59');
        this.options.params.dateStart = moment(this.inputs.dateStart.value).format('YYYY-MM-DD 00:00');
        this.showLogsList = true;

        if (this.refresh_token) {
          this.refresh();
        }
        this.refresh_token = true;
      }
    },
    refresh: function () {
      this.$refs['logs-actividad-table'].refresh();
    },
    getFilterColumns: function () {
      return this.$refs['logs-actividad-table'].query;
    },
    getOrderByColumn: function () {
      return this.$refs['logs-actividad-table'].orderBy;
    },
    exportar: function () {
      const filterColumns = this.getFilterColumns();
      const orderByColumn = this.getOrderByColumn();

      let params = Object.keys(filterColumns);
      let obj = this._data.options.params;

      // for each column in the table
      const filters = {};
      for (let index = 0; index < params.length; index++) {
        const element = params[index];

        if (element === 'fecha') {
          filters[element + '__gte'] = obj['dateStart'];
          filters[element + '__lte'] = obj['dateEnd'];
        }
      }

      // Query parameters and options
      let orderBy = (orderByColumn.column) ? orderByColumn.column : null;
      orderBy = (orderByColumn.ascending) ? '-' + orderBy : orderBy;
      const queryConfig = {filters: filters, orderBy: orderBy};
      const options = {responseType: 'blob'};

      // Realizamos la petición
      this.downloading = true;
      return this.$http.post('lista-logs-actividad/exportar/', queryConfig, options).then(function (response) {
        this.downloading = false;
        const excelFile = new File([response.data], 'listado_logs_actividad.xlsx');
        FileSaver.saveAs(excelFile, excelFile.name);
      }, function (e) {
        this.downloading = false;
        this.dispatch('error', e);
        EventBus.$emit('show-error-alert', 'Error al exportar a csv');
      }.bind(this));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/SystemManagement/logs-management/LogsActividad.vue